import { render, staticRenderFns } from "./CustomerOTPManagement.vue?vue&type=template&id=69afeb0c&scoped=true&"
import script from "./CustomerOTPManagement.vue?vue&type=script&lang=js&"
export * from "./CustomerOTPManagement.vue?vue&type=script&lang=js&"
import style0 from "./CustomerOTPManagement.vue?vue&type=style&index=0&id=69afeb0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69afeb0c",
  null
  
)

export default component.exports